import React, { type FC } from 'react'

import type { ReadonlyDate } from '../../../../utils'

import { FormattedDateTime } from '../../Internationalization'
import { Chip } from '../Chip'
import type { DateTimeRangeValue } from './DateTimeRangePicker'

type DateTimeRangeChipProps = Readonly<{
    value: DateTimeRangeValue
    onClear: () => void
}>

// An open-started range ("up to end") is prefixed with a dash to distinguish it from an open-ended one
// ("from start onward"), which needs none; a full range separates its two bounds with a dash.
const dashSeparator = (start: ReadonlyDate | null, end: ReadonlyDate | null): string => {
    if (!end) return ''
    return start ? ' – ' : '– '
}

export const DateTimeRangeChip: FC<DateTimeRangeChipProps> = ({ value: { start, end }, onClear }) => (
    <Chip
        label={
            <>
                {start && <FormattedDateTime date={start} format="dateRangeChip" />}
                {dashSeparator(start, end)}
                {end && <FormattedDateTime date={end} format="dateRangeChip" />}
            </>
        }
        onDelete={onClear}
        variant="primary"
        data-testid="date-range-chip"
    />
)
